import { MODULE_PATHS, PUBLIC_CUSTOM_PAGE_PATH } from '../../../utils/const';
import { PageTypeId } from '../const';
import { NavigationUrls } from '../types';

export const defaultNavigationUrls: NavigationUrls = {
	[PageTypeId.ActivityList]: MODULE_PATHS.activityList,
	[PageTypeId.TaskList]: MODULE_PATHS.activityTaskList,
	[PageTypeId.AgencyList]: MODULE_PATHS.agencyList,
	[PageTypeId.AgencyStructure]: MODULE_PATHS.structure,
	[PageTypeId.PublicJobAllJobs]: MODULE_PATHS.allJobs,
	[PageTypeId.ConnectApiUserList]: MODULE_PATHS.apiUserList,
	[PageTypeId.ApplicationForm]: MODULE_PATHS.applicationForm,
	[PageTypeId.ApplicationList]: MODULE_PATHS.applicationsList,
	[PageTypeId.AuditTrailList]: MODULE_PATHS.auditTrailList,
	[PageTypeId.AutomationDetails]: MODULE_PATHS.automationDetails,
	[PageTypeId.AutomationList]: MODULE_PATHS.automationList,
	[PageTypeId.AutomationLogList]: MODULE_PATHS.automationLogList,
	[PageTypeId.CalculationSchemeList]: MODULE_PATHS.calculationSchemeList,
	[PageTypeId.CandidateChangeList]: MODULE_PATHS.candidateChangeList,
	[PageTypeId.CandidateList]: MODULE_PATHS.candidateList,
	[PageTypeId.PensionList]: MODULE_PATHS.candidatePensionList,
	[PageTypeId.CandidateCandidateStatusMapping]: MODULE_PATHS.candidateStatusMappingList,
	[PageTypeId.CaoList]: MODULE_PATHS.caoList,
	[PageTypeId.CaoInstanceList]: MODULE_PATHS.caoListInstance,
	[PageTypeId.CaoNewsList]: MODULE_PATHS.caoNewsList,
	[PageTypeId.CaoWagesList]: MODULE_PATHS.caoWagesList,
	[PageTypeId.CaoWagesRequestsList]: MODULE_PATHS.caoWagesRequestList,
	[PageTypeId.TimecardList]: MODULE_PATHS.clockwiseList,
	[PageTypeId.CommentList]: MODULE_PATHS.commentsList,
	[PageTypeId.CommunitiesList]: MODULE_PATHS.communitiesList,
	[PageTypeId.ComponentModelList]: MODULE_PATHS.componentModelList,
	[PageTypeId.ConnectDashboard]: MODULE_PATHS.connectDashboardList,
	[PageTypeId.ConnectSettings]: MODULE_PATHS.connectSettings,
	[PageTypeId.ConnectorList]: MODULE_PATHS.connectorList,
	[PageTypeId.EmployerContactPersonsList]: MODULE_PATHS.contactPersonList,
	[PageTypeId.ContractList]: MODULE_PATHS.contractsList,
	[PageTypeId.ContractBulkUpdateRequestList]: MODULE_PATHS.contractsUpdateList,
	[PageTypeId.CustomCaoList]: MODULE_PATHS.customCaoList,
	[PageTypeId.CustomCaoInstanceList]: MODULE_PATHS.customCaoInstanceList,
	[PageTypeId.CustomerCustomerDetails]: MODULE_PATHS.customerDetails,
	[PageTypeId.InvoiceComponentsList]: MODULE_PATHS.customerInvoiceComponentList,
	[PageTypeId.CustomerInvoiceList]: MODULE_PATHS.customerInvoiceList,
	[PageTypeId.CustomerList]: MODULE_PATHS.customerList,
	[PageTypeId.CustomerSubscriptionList]: MODULE_PATHS.customerSubscriptionsList,
	[PageTypeId.Dashboard]: MODULE_PATHS.dashboard,
	[PageTypeId.ManagementInformation]: MODULE_PATHS.managementInformation,
	[PageTypeId.DealList]: MODULE_PATHS.dealsList,
	[PageTypeId.DocumentList]: MODULE_PATHS.documentList,
	[PageTypeId.DocumentSettingsList]: MODULE_PATHS.documentSettingsList,
	[PageTypeId.DocumentTemplateList]: MODULE_PATHS.documentTemplateList,
	[PageTypeId.DomainValuesCAOMapping]: MODULE_PATHS.domainValueCaoMappingList,
	[PageTypeId.DomainValuesDetails]: MODULE_PATHS.domainValueDetail,
	[PageTypeId.DomainValuesList]: MODULE_PATHS.domainValueList,
	[PageTypeId.DomainValuesMapping]: MODULE_PATHS.domainValueMappingList,
	[PageTypeId.ConnectEmailSenderAuthList]: MODULE_PATHS.emailSenderAuthList,
	[PageTypeId.EmployerList]: MODULE_PATHS.employerList,
	[PageTypeId.FlexNetCustomerList]: MODULE_PATHS.flexNetCustomerList,
	[PageTypeId.FlexNetHostDetails]: MODULE_PATHS.flexNetHostDetail,
	[PageTypeId.FlexNetHostList]: MODULE_PATHS.flexNetHostList,
	[PageTypeId.FlexNetHostSettings]: MODULE_PATHS.flexNetHostSettingsDetail,
	[PageTypeId.FormUserDetails]: MODULE_PATHS.formCommonDetails,
	[PageTypeId.FormDesignerList]: MODULE_PATHS.formDesignerList,
	[PageTypeId.FormUserList]: MODULE_PATHS.formList,
	[PageTypeId.FormPublic]: MODULE_PATHS.formPublic,
	[PageTypeId.ConnectFSApiLogList]: MODULE_PATHS.fsApiLogList,
	[PageTypeId.IllnessList]: MODULE_PATHS.illnessList,
	[PageTypeId.ConnectIncomingList]: MODULE_PATHS.incomingMessageList,
	[PageTypeId.ConnectIncomingLogList]: MODULE_PATHS.incomingMessageLogList,
	[PageTypeId.InvoiceList]: MODULE_PATHS.invoiceList,
	[PageTypeId.ShareJobBoardDetails]: MODULE_PATHS.jobBoardDetails,
	[PageTypeId.ShareJobBoardInstanceDetails]: MODULE_PATHS.jobBoardInstanceDetail,
	[PageTypeId.ShareJobBoardInstanceList]: MODULE_PATHS.jobBoardInstanceList,
	[PageTypeId.ShareJobBoardList]: MODULE_PATHS.jobBoardList,
	[PageTypeId.JobDetails]: MODULE_PATHS.jobCommonDetails,
	[PageTypeId.JobList]: MODULE_PATHS.jobList,
	[PageTypeId.ShareJobPostDetails]: MODULE_PATHS.jobPostDetail,
	[PageTypeId.ShareJobPostList]: MODULE_PATHS.jobPostList,
	[PageTypeId.LabelLabelDetails]: MODULE_PATHS.labelDetails,
	[PageTypeId.LabelList]: MODULE_PATHS.labelList,
	[PageTypeId.ModelMatrixDetails]: MODULE_PATHS.modelMatrixDetail,
	[PageTypeId.ModelMatrixInstanceDetails]: MODULE_PATHS.modelMatrixInstanceDetail,
	[PageTypeId.ModelMatrixInstanceList]: MODULE_PATHS.modelMatrixInstanceList,
	[PageTypeId.ModelMatrixList]: MODULE_PATHS.modelMatrixList,
	[PageTypeId.NewsAdminDetails]: MODULE_PATHS.newsAdminCommonDetails,
	[PageTypeId.NewsDetails]: MODULE_PATHS.newsCommonDetails,
	[PageTypeId.NewsList]: MODULE_PATHS.newsList,
	[PageTypeId.NewsAdminList]: MODULE_PATHS.newsadminList,
	[PageTypeId.SurveyListOptOutList]: MODULE_PATHS.optOutList,
	[PageTypeId.ConnectOutgoingDetails]: MODULE_PATHS.outgoingMessageDetails,
	[PageTypeId.ConnectOutgoingList]: MODULE_PATHS.outgoingMessageList,
	[PageTypeId.ConnectOutgoingLogList]: MODULE_PATHS.outgoingMessageLogList,
	[PageTypeId.LabelPagesList]: MODULE_PATHS.pageList,
	[PageTypeId.LabelPageDetails]: MODULE_PATHS.pageDetails,
	[PageTypeId.PaymentList]: MODULE_PATHS.paymentList,
	[PageTypeId.PayslipList]: MODULE_PATHS.payslipList,
	[PageTypeId.CandidatePeriodicComponentsList]: MODULE_PATHS.periodicComponentsList,
	[PageTypeId.CandidatePhaseList]: MODULE_PATHS.phaseList,
	[PageTypeId.ProformaDetail]: MODULE_PATHS.proformaDetails,
	[PageTypeId.ProformaList]: MODULE_PATHS.proformaList,
	[PageTypeId.PublicDocumentLogin]: MODULE_PATHS.publicDocumentAuthentication,
	[PageTypeId.PublicDocumentList]: MODULE_PATHS.publicDocumentList,
	[PageTypeId.PublicEmployerEmployerList]: MODULE_PATHS.publicEmployerList,
	[PageTypeId.PublicJobApply]: MODULE_PATHS.publicJobApply,
	[PageTypeId.PublicJobJobList]: MODULE_PATHS.publicJobList,
	[PageTypeId.NewsPublicNewsList]: MODULE_PATHS.publicNewsList,
	[PageTypeId.InvoicePurchaseInvoice]: MODULE_PATHS.purchaseInvoiceList,
	[PageTypeId.RateClassesList]: MODULE_PATHS.rateClassList,
	[PageTypeId.CandidateReservationList]: MODULE_PATHS.reservationList,
	[PageTypeId.RoleList]: MODULE_PATHS.rolesList,
	[PageTypeId.SafetyList]: MODULE_PATHS.safetyList,
	[PageTypeId.SavedFilterSystemFiltersList]: MODULE_PATHS.savedFilterAdminList,
	[PageTypeId.SavedFilterAlertLogsList]: MODULE_PATHS.savedFilterLogsList,
	[PageTypeId.SavedFilterMyFiltersList]: MODULE_PATHS.savedFilterMyList,
	[PageTypeId.SavedFilterOtherUsersFiltersList]: MODULE_PATHS.savedFilterOwnList,
	[PageTypeId.SettingList]: MODULE_PATHS.settingList,
	[PageTypeId.ShareLogDetails]: MODULE_PATHS.shareLogDetail,
	[PageTypeId.ShareLogList]: MODULE_PATHS.shareLogList,
	[PageTypeId.SubscriberList]: MODULE_PATHS.subscriberList,
	[PageTypeId.CustomerSubscriptionSettingDetails]: MODULE_PATHS.subscriptionSettingDetails,
	[PageTypeId.CustomerSubscriptionSettingList]: MODULE_PATHS.subscriptionSettingList,
	[PageTypeId.SupplierOrganizationList]: MODULE_PATHS.suppliersList,
	[PageTypeId.ConnectCustomerAccessRequestList]: MODULE_PATHS.supportAccessList,
	[PageTypeId.SurveyAdminDetails]: MODULE_PATHS.surveyAdminDetails,
	[PageTypeId.SurveyAdminList]: MODULE_PATHS.surveyAdminList,
	[PageTypeId.SurveyList]: MODULE_PATHS.surveyList,
	[PageTypeId.TagList]: MODULE_PATHS.tagList,
	[PageTypeId.LabelTemplates]: MODULE_PATHS.templateList,
	[PageTypeId.CalculationSchemeClockwiseTest]: MODULE_PATHS.testCalculationScheme,
	[PageTypeId.TextModelList]: MODULE_PATHS.textModelList,
	[PageTypeId.CaoWmlList]: MODULE_PATHS.wmlList,
	[PageTypeId.UserList]: MODULE_PATHS.userList,
	[PageTypeId.BackofficeIndex]: MODULE_PATHS.backofficeActionPage,
	[PageTypeId.BackofficeJournalTransferFilesList]: MODULE_PATHS.journalTransferFilesList,
	[PageTypeId.BackofficeProcessingList]: MODULE_PATHS.backofficeProcessingList,
	[PageTypeId.BackofficePaymentTransferFilesList]: MODULE_PATHS.backofficePaymentTransferFilesList,
	[PageTypeId.LabelTranslations]: MODULE_PATHS.translationList,
	[PageTypeId.Faq]: PUBLIC_CUSTOM_PAGE_PATH.faq,
	[PageTypeId.Help]: PUBLIC_CUSTOM_PAGE_PATH.help,
	[PageTypeId.AboutUs]: PUBLIC_CUSTOM_PAGE_PATH.aboutUs,
	[PageTypeId.ContactUs]: PUBLIC_CUSTOM_PAGE_PATH.contactUs,
	[PageTypeId.PrivacyStatement]: PUBLIC_CUSTOM_PAGE_PATH.privacyStatement,
	[PageTypeId.CvdPolicy]: PUBLIC_CUSTOM_PAGE_PATH.cvdPolicy,
	[PageTypeId.SecurityStatement]: PUBLIC_CUSTOM_PAGE_PATH.securityStatement,
	[PageTypeId.TermsOfUse]: PUBLIC_CUSTOM_PAGE_PATH.termsOfUse,
};
